import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const SignUpEmail = styled.div`
  background-color: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  margin: 0 auto;
  width: 916px;

  ${DEVICE.tablet.mid} {
    width: 458px;
    flex-direction: column;
  }
  ${DEVICE.mobile.max} {
    flex-direction: column;
    width: 100%;
  }
`;

const SignUpEmailFormFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 8px;
  text-align: center;
`;

const SignInWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-8);
`;

const SignUpEmailFormNote = styled.div`
  background-color: var(--color-bg-weaker);
  color: var(--color-fg-weaker);
  margin-top: auto;
  padding: 8px 12px;
  text-align: left;

  ${DEVICE.mobile.max} {
    margin-top: var(--size-padding-24);
  }

  a {
    color: var(--color-fg-weaker);
    text-decoration: underline;
  }
`;

const SignUpEmailForm = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 640px;
  padding: 40px 40px 0 40px;
  width: 100%;

  ${DEVICE.tablet.max} {
    min-height: auto;
    padding: 24px;
  }
`;

const SignUpEmailFormBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
`;

export {
  SignInWrapper,
  SignUpEmail,
  SignUpEmailForm,
  SignUpEmailFormBody,
  SignUpEmailFormFooter,
  SignUpEmailFormNote
};
